import type { ChatCardProps } from "../../types/ChatCard";
import { ConfirmationCard } from "./copilot/ConfirmationCard";
import { LinkCard } from "./copilot/LinkCard";
import { AccessGroupListCard } from "./copilot/ListCards/AccessGroupListCard";
import { InviteLinkListCard } from "./copilot/ListCards/InviteLinkListCard";
import { MemberListCard } from "./copilot/ListCards/MemberListCard";
import { ProfileFieldListCard } from "./copilot/ListCards/ProfileFieldListCard";
import { SegmentListCard } from "./copilot/ListCards/SegmentListCard";
import { SpaceGroupListCard } from "./copilot/ListCards/SpaceGroupListCard";
import { SpaceListCard } from "./copilot/ListCards/SpaceListCard";
import { TagListCard } from "./copilot/ListCards/TagListCard";
import { PreviewCard } from "./copilot/PreviewCard";

const CARD_COMPONENTS = {
  member_listing_card: MemberListCard,
  confirmation_card: ConfirmationCard,
  link_card: LinkCard,
  invitation_link_listing_card: InviteLinkListCard,
  member_tag_listing_card: TagListCard,
  profile_field_listing_card: ProfileFieldListCard,
  space_group_listing_card: SpaceGroupListCard,
  space_listing_card: SpaceListCard,
  access_group_listing_card: AccessGroupListCard,
  community_segment_listing_card: SegmentListCard,
  preview_card: PreviewCard,
} as const;

export const ChatCard = ({ type, content }: ChatCardProps) => {
  const Component = CARD_COMPONENTS[type] as React.ComponentType<
    typeof content
  >;

  if (!Component) {
    return null;
  }

  return <Component {...content} />;
};
